import { createSlice } from '@reduxjs/toolkit';

const initialState={
    emms:null
}
export const emmsSlice = createSlice({
  name: 'emms',
  initialState,
  reducers: {

    
      
      setEmms: (state, action) => {
        state.emms = action.payload;
        
      },
      
    
    setLogoutEmms: (state,action)=>{
      state.emms=null
    }
  },
});

export const {  setEmms,setLogoutEmms } = emmsSlice.actions;

export default emmsSlice.reducer;
